import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { Router } from '@angular/router';

declare var jQuery: any;
declare var $: any;
declare var Faqs: any;

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html'
})


export class FaqComponent implements OnInit {

    public title: string;

    constructor(public router: Router) { }

    ngOnInit() {
        if (environment.faqs === 'valoriza') {
                this.router.navigate(['/home/faqValoriza']);
        } else if (environment.faqs === 'soria') {
            this.router.navigate(['/home/faqSoria']);
        } else if (environment.faqs === 'guadalagua') {
            this.router.navigate(['/home/faqGuadalagua']);
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/faq.component.ts